import React from "react";
import { CurrentApplicationContextProvider } from "../../Context/CurrentApplicationContext/CurrentApplicationContext";
import { Outlet, useParams } from "react-router-dom";

const CurrentApplicationLayout: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  if (!slug) return null;
  return (
    <CurrentApplicationContextProvider slug={slug}>
      <Outlet />
    </CurrentApplicationContextProvider>
  );
};

export default CurrentApplicationLayout;
